import { useUserStatus } from '@/hooks/useUserStatus'
import { useEffect, useState } from 'react'
import { InactiveUserModal } from './InactiveUserModal'

interface InactiveUserGuardProps {
  children: React.ReactNode
}

export const InactiveUserGuard = ({ children }: InactiveUserGuardProps) => {
  const { isInactive, userData } = useUserStatus()
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (isInactive && userData) {
      setShowModal(true)
    }
  }, [isInactive, userData])

  if (isInactive) {
    return (
      <>
        <InactiveUserModal open={showModal} onOpenChange={setShowModal} />
        <div className='min-h-screen bg-neutral-50 flex items-center justify-center'>
          <div className='text-center'>
            <div className='w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4'>
              <svg
                className='w-8 h-8 text-red-600'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
                role='img'
                aria-label='Warning icon'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z'
                />
              </svg>
            </div>
            <h1 className='text-xl font-semibold text-neutral-900 mb-2'>Account Inactive</h1>
            <p className='text-neutral-600'>Please contact your administrator to restore access.</p>
          </div>
        </div>
      </>
    )
  }

  return <>{children}</>
}
